export enum WALKING_DESIGN_VERSION {
	V1 = 'walkingDesignV1',
	V2 = 'walkingDesignV2',
}
